import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { InformationCircleIcon } from '@heroicons/react/20/solid';

/**
 * Displays a tooltip with information when hovered over.
 *
 * @param {string} info - text to be displayed in the tooltip
 * @param {string} formatting - additional classes to be applied to the tooltip
 *
 * @returns a React component
 */

function dispatchTooltip(payload) {
  const event = new CustomEvent('showTooltip', { detail: payload });
  window.dispatchEvent(event);
}

export default function ToolTip({ info, formatting, tooltipClassName }) {
  function handlePointerEnter(e) {
    dispatchTooltip({
      x: e.clientX,
      y: e.clientY,
      message: info,
      className: tooltipClassName,
    });
  }

  function handlePointerMove(e) {
    dispatchTooltip({
      x: e.clientX,
      y: e.clientY,
      message: info,
      className: tooltipClassName,
    });
  }

  function handlePointerLeave() {
    dispatchTooltip(null);
  }

  useEffect(
    () => () => {
      dispatchTooltip(null);
    },
    [],
  );

  return (
    <div className={`relative self-center ${formatting}`}>
      <div
        className="self-center px-1.5"
        onPointerEnter={handlePointerEnter}
        onPointerMove={handlePointerMove}
        onPointerLeave={handlePointerLeave}
      >
        <InformationCircleIcon className="h-4 w-4 text-gray-300" />
      </div>
    </div>
  );
}
ToolTip.propTypes = {
  info: PropTypes.string.isRequired,
  formatting: PropTypes.string,
  tooltipClassName: PropTypes.string,
};
ToolTip.defaultProps = {
  formatting: '',
  tooltipClassName: '',
};
